export const SYNC_NUMBER_OF_ZONES_OPTIONS = '@@numberOfZones/sync'

export const SET_NUMBER_OF_ZONES_OPTIONS = '@@numberOfZones/set'

export const SET_NUMBER_OF_ZONES_INITIAL_OPTIONS = '@@numberOfZones/setInitialOptions'
export const SET_NUMBER_OF_ZONES_CURRENT_OPTIONS = '@@numberOfZones/setCurrentOptions'

export const SET_NUMBER_OF_ZONES_VALIDATION = '@@numberOfZones/setNumberOfZonesValidation'
